/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import KeenSlider from '../../components/slider/slider'
import spriteRender from './core/sprite'

window.addEventListener('DOMContentLoaded', () => {
  spriteRender('bdda')

  const header = document.getElementById('js-header')

  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      header.classList.add('header-scrolled')
    } else {
      header.classList.remove('header-scrolled')
    }
  })
})
